import { createContext } from '@direct-frontend/modules-context';
import type { Nullable } from '@direct-frontend/stdlib';
import type { ENV } from '@adv-frontend/yastore-modules/types';

export interface RequestContext {
    /** Включен ли SSR по-умолчанию */
    isSsrEnabled: boolean;
    isSsrDisabled?: boolean;
    /** Источник статических ресурсов интерфейса, заданный через STATIC_DELIVERY. */
    staticDelivery?: 'local' | 'cdn';
    /** Платформа по user-agent */
    platform: 'desktop' | 'touch';
    /** Окружение */
    env: ENV;
    /** Признак того, что окружение является beta окружением */
    isPullRequestBeta: boolean;
    /** Номер pull request */
    pullRequestNumber: string;
    /** Ссылка на чекаут */
    checkoutOrigin: string;
    /** Ключ к апи яндекс карт */
    yandexMapApiKey: string;
    /** Ключ к апи geo-suggest яндекс карт */
    yandexMapGeoSuggestAPIKey: string;
    /** Счетчик яндекс метрики */
    yaCounter: number;
    /** Id запроса */
    requestId: string;
    /** Признак, что запрос к YCP домену (# checkout.merchants.yandex.ru) */
    isYCPDomain: boolean;
    /** Признак, что запрос к sandbox домену (# sandbox.b2b.kit.yandex.ru) */
    isSandbox: boolean;
    /** Режим темы из cookie (для SSR) */
    themeMode: 'light' | 'dark' | 'system';
    /** Базовый URL статики основного приложения */
    staticBase?: string;
    csrfToken?: Nullable<string>;
}

export const { setContext: setRequestContext, getContext: getRequestContext } = createContext<RequestContext>({
    name: 'requestContext',
});
